import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
/** @returns Whether a non-first group gets a rule under the menu's heading policy. */
export function shouldShowGroupSeparator({ hasPreviousGroup, hasHeading, variant, }) {
    switch (variant) {
        case undefined:
            return hasPreviousGroup;
        case 'commandMenu':
            return hasPreviousGroup && !hasHeading;
        case 'suggestDropdown':
            return hasPreviousGroup && hasHeading;
        default:
            return assertUnreachableValue(variant);
    }
}
//# sourceMappingURL=shouldShowGroupSeparator.js.map